export const bioParagraphs = [
  'Sou Silvano Marques, desenvolvedor full‑stack. Trabalho remoto com a Aftercode desde 2023, hoje como pleno, atuando em todo o ciclo de produtos para web, mobile e desktop.',
  'Minha stack do dia a dia é TypeScript em todos os ambientes: Next.js no web, React Native no mobile e Nest.js no back‑end, com Postgres, Redis e RabbitMQ. Também escrevo Kotlin com Jetpack Compose quando o produto pede performance nativa em Android.',
];

export const heroTagline = 'Desenvolvedor full‑stack.';

export const heroSubtitle = 'Construindo produtos para web, mobile e desktop.';

export const heroIntro =
  'Desenvolvedor full‑stack na Aftercode. Construindo produtos para web, mobile e desktop, do front em React e Jetpack Compose ao back em Nest, Postgres e gRPC.';

export const projectsDisclaimer =
  'Projetos que desenvolvi para estudar ou melhorar habilidades específicas no meu tempo livre.';
